export default function RetiredDiagnosticsNotice() {
  return (
    <section aria-label="Pagina non disponibile" className="mx-auto max-w-2xl space-y-3 p-4 sm:p-6">
      <h2 className="text-xl font-semibold leading-tight">Pagina non disponibile</h2>
      <p className="text-base font-normal leading-relaxed text-muted-foreground">
        Questa pagina è stata ritirata. Torna al CRM per continuare il lavoro.
      </p>
      <a href="/" className="inline-flex min-h-11 items-center rounded-md border border-border px-4 py-2 text-sm font-medium underline-offset-4 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2">
        Torna al CRM
      </a>
    </section>
  );
}
